import { useEffect } from 'react'

import { useSelector } from 'react-redux'

import { googleAnalyticsLogger } from '~/shared/services'
import { selectGoogleAdsConversions } from '~/shared/store/common'

export const useGAConversionTracker = (): void => {
  const googleAdsConversions = useSelector(selectGoogleAdsConversions)

  useEffect(() => {
    googleAnalyticsLogger.configure(googleAdsConversions)
  }, [googleAdsConversions])
}
